// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"0a48ab1e","447":"0015688d","595":"0a48ab1e"}[chunkId] + ".chunk.css";
};